module.exports = __webpack_public_path__ + "static/media/poly.0423fad0.svg";